// @review: seperate legacy/modern builds?

if (process.env.NODE_ENV === 'production') {
  require('@babel/polyfill');
}
